export default __webpack_public_path__ + "8efb0b29740c41d3d11955524aec5d8a.png";